import type { Data } from 'framework/types';
import { Typography } from '@mui/material';
import { NOTE_TAG_ALIAS } from 'domain/people/employee/Timeline/shared/input/EmployeeNoteTagDropdown';

type EmployeeNoteTagProps = {
  entity: Data;
};

const EmployeeNoteTag = ({ entity }: EmployeeNoteTagProps) => {
  const tag: keyof typeof NOTE_TAG_ALIAS = entity.getValueBySource('tag');
  const displayedTag = NOTE_TAG_ALIAS[tag];

  if (!displayedTag) {
    return null;
  }

  return (
    <Typography component="div" variant="body2" color="textSecondary">
      <i className="fa fa-star" aria-hidden style={{ marginRight: 0.5 }} />
      {displayedTag}
    </Typography>
  );
};

export default EmployeeNoteTag;
